import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { PersonaId } from '../../App';
interface MainLayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string, query?: string) => void;
  persona: PersonaId | null;
}
export function MainLayout({
  children,
  currentPage,
  onNavigate,
  persona
}: MainLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleNavigate = (page: string, query?: string) => {
    setSidebarOpen(false);
    onNavigate(page, query);
  };
  return <div className="flex h-screen w-full bg-slate-50 overflow-hidden" data-id="element-76">
      {/* Mobile overlay */}
      {sidebarOpen && <div className="fixed inset-0 z-20 bg-black/50 lg:hidden" onClick={() => setSidebarOpen(false)} aria-hidden="true" data-id="element-77" />}

      {/* Sidebar — hidden on mobile unless open */}
      <div className={`fixed inset-y-0 left-0 z-30 lg:relative lg:flex lg:translate-x-0 transition-transform duration-200 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-78">
        <Sidebar currentPage={currentPage} onNavigate={handleNavigate} persona={persona} data-id="element-79" />
      </div>

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-80">
        <Header onNavigate={handleNavigate} persona={persona} onToggleSidebar={() => setSidebarOpen(v => !v)} data-id="element-81" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-82">
          <div className="max-w-6xl mx-auto" data-id="element-83">{children}</div>
        </main>
      </div>
    </div>;
}